// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { jsonObjectGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    sessionUid: z.string().min(1).max(128),
    accountId: z.string().min(1).max(128),
    lastSubmission: jsonObjectGuard.optional(),
    clientId: z.string().max(21).nullable().optional(),
    cimdClientId: z.string().max(2048).nullable().optional(),
    createdAt: z.number().optional(),
    updatedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    sessionUid: z.string().min(1).max(128),
    accountId: z.string().min(1).max(128),
    lastSubmission: jsonObjectGuard,
    clientId: z.string().max(21).nullable(),
    cimdClientId: z.string().max(2048).nullable(),
    createdAt: z.number(),
    updatedAt: z.number(),
});
export const OidcSessionExtensions = Object.freeze({
    table: 'oidc_session_extensions',
    tableSingular: 'oidc_session_extension',
    fields: {
        tenantId: 'tenant_id',
        sessionUid: 'session_uid',
        accountId: 'account_id',
        lastSubmission: 'last_submission',
        clientId: 'client_id',
        cimdClientId: 'cimd_client_id',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
    },
    fieldKeys: [
        'tenantId',
        'sessionUid',
        'accountId',
        'lastSubmission',
        'clientId',
        'cimdClientId',
        'createdAt',
        'updatedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
